/* eslint-disable no-nested-ternary */
import React from 'react';
import Moment from 'moment';
import { Link } from 'react-router-dom';
//import $ from "jquery";
import './paquete-detalle-panel-comprar.css';
import TwitterTweetButton from '../../../../commons/social-networks/twitter/tweet-button';
import FacebookShareButton from '../../../../commons/social-networks/facebook/share-button';
import WhatsappShareButton from '../../../../commons/social-networks/whatsapp/share-button';

const PanelPrincipal = (props) => {
  /*
  $(window).scroll(function() {
    if ($(document).height() * 0.15 <= $(window).scrollTop()) {
      $("#resumen-on-scroll").css("display", "block");
    } else {
      $("#resumen-on-scroll").css("display", "none");
    }
  });
  */
  const imagenPaquete = props.paquete.imagen
    ? props.paquete.imagen
    : `${process.env.RAZZLE_URL}/assets/img/paquete-por-defecto.jpg`;
  const imagenPrincipal = `url('${imagenPaquete}')`;
  const destinoFondoStyle = {
    height: '450px',
    background: imagenPrincipal,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'brightness(98%)',
  };
  const fechaSalida = Moment(props.paquete.salidas[0].fechaSalida).format(
    'DD/MM/YYYY',
  );

  const cantPasajeros = props.paquete.pasajeros !== null
    ? props.paquete.pasajeros.length > 0 ? props.paquete.pasajeros.length : props.cantidadPasajeros : parseInt(props.cupos, 10);

  const precio = props.formatearPrecio(
    props.paquete.salidas[0].precios.precioNeto,
    props.paquete.salidas[0].precios.impuestos,
    props.paquete.salidas[0].precios.iva,
    cantPasajeros,
  );

  const botonComprar = () => (
    <Link
      to={{
        pathname: '/checkout',
        search: `?t=${props.referencia}&h=${props.distribucion}&p=${props.proveedorId}`,
      }}
      className='btn paquete-detalle'
    >
      {' '}
      {' '}
      Comprar
    </Link>
  );

  let { cupos } = props.paquete.salidas[0];
  cupos = cupos !== 0 ? `Quedan ${cupos} lugares` : 'Consultar Disponibilidad';

  return (
    <div className='precio info'>
      <div className='paquete-float affix-top' id='resumen-on-scroll' data-spy='affix' data-offset-top='300'>
        <div className='container'>
          <div className='col-lg-4 col-md-4 col-xs-6 hidden-xs hidden-sm'>
            <ul className='contenido text-center'>
              <li className='destino texto-dinamico'>
                {props.paquete.nombre}
              </li>
              <li className='noches'>
                {`${props.paquete.cantNoches} Noches`}
              </li>
            </ul>
          </div>
          <div className='col-lg-3 col-md-3 col-xs-6 hidden-xs hidden-sm'>
            <ul className='contenido text-center'>
              <li className='salida'>
                Salida
                {fechaSalida}
              </li>
              <li className='origen'>
                Desde
                {' '}
                {props.paquete.salidas[0].origen}
              </li>
            </ul>
          </div>
          <div className='col-lg-3 col-md-3 col-xs-6'>
            <ul className='contenido text-center'>
              <li className='precio'>
                <span>ARS</span>
                {' '}
                {precio}
              </li>
              <li className='condicion'>Precio por persona</li>
              <li className='condicion'>
                viajando
                {props.cantidadPasajeros}
              </li>

            </ul>
          </div>
          <div className='col-lg-2 col-md-2 col-xs-6'>
            <ul className='contenido text-center'>
              <li className='btn-comprar'>
                {botonComprar(props.paquete.proveedorId)}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='destino fondo position-relative' style={destinoFondoStyle}>
        <div className='panel panel-default custom precio trasnparente'>
          <div className='disponibilidad'>{cupos}</div>
          <div className='salida p-top'>
            {`Salida ${fechaSalida}`}
          </div>
          <div className='origen p-top'>
            {`DESDE ${props.paquete.salidas[0].origen}`}
          </div>
          <div className='precio p-top'>
            <span className='cambio'>ARS </span>
            {' '}
            {precio}
          </div>
          <div className='condicion p-top'>Precio por persona</div>
          <div className='condicion p-top'>
            viajando
            {props.cantidadPasajeros}
          </div>
          {botonComprar(props.paquete.proveedorId)}

          <div className='social-networks' style={{ textAling: 'center' }}>
            <div className='titulo'>Compartir en:</div>
            <TwitterTweetButton className='btn-item' />

            <WhatsappShareButton className='btn-item' />

            <FacebookShareButton className='btn-item' />
          </div>
        </div>
        <div className='destino titulo'>
          <div className='info paquete transparente'>
            <ul className='list-inline'>
              <li className='list-inline-item'>
                <div className='titulo'>
                  {props.paquete.nombre}
                </div>
              </li>
              <li className='list-inline-item pull-right'>
                <span className='noches'>
                  <b>
                    {`${props.paquete.cantNoches} noches`}
                  </b>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PanelPrincipal;
